import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'notif-primary',
  templateUrl: './notif-primary.component.html',
  styleUrls: ['./notif-primary.component.css']
})
export class NotifPrimaryComponent implements OnInit {
  @Input() msg : string;
  @Input() closable : string;

  constructor() { }

  ngOnInit() {
  }

}
